/* eslint-disable */
import { Route, RouteProps } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import clx from "clsx";
import PropTypes from "prop-types";
import { SearchIcon } from "@heroicons/react/outline";
import { useState } from "react";

function Input({
  error,
  disabled,
  leftIcon,
  rightIcon,
  colSpan = 1,
  size = "base",
  value = "",
  variant = "outline",
  ...props
}) {
  let cl = clx(
    ` col-span-${colSpan} appearance-none transition-all duration-300 ease-in-out rounded  px-3 text-gray-800  leading-tight outline-none  w-full  focus:border-2`,
    {
      "bg-gray-100 cursor-not-allowed": disabled,
      "border border-red-400": error,
      "h-8 text-xs": size === "sm",
      "h-10 text-sm": size == "base",
      "h-12 text-base": size == "lg",

      "pl-10": leftIcon,
      "pr-10": rightIcon,

      "bg-blueGray-100 focus:border focus:border-blueGray-300":
        variant == "filled" && !error,
      "border-transparent border-gray-300 focus:border-blue-500":
        variant == "outline" && !error,
      "border-none": variant == "file" && !error,
    }
  );

  return (
    <div className="relative">
      {leftIcon && (
        <div className="absolute text-gray-600 w-10  left-0 top-0   flex justify-center items-center h-full">
          <div className="w-5 h-5">{leftIcon}</div>
        </div>
      )}

      <input disabled={disabled} value={value} className={cl} {...props} />
      {rightIcon && (
        <div className="absolute text-gray-600 w-10  right-0 top-0   flex justify-center items-center h-full">
          <div className="w-5 h-5">{rightIcon}</div>
        </div>
      )}
    </div>
  );
}

Input.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  leftIcon: PropTypes.any,
  rightIcon: PropTypes.any,
  size: PropTypes.oneOf(["sm", "base", "lg"]),
  value: PropTypes.any,
  variant: PropTypes.oneOf(["outline", "filled"]),
};

export const BaseLayout: React.FC = ({ children }) => {
  const [searchText, setSearchText] = useState("");
  const handleChange = (e) => {
    setSearchText(e.target.value);
  };
  return (
    <div className="flex ">
      <Sidebar />

      {/* //! Content */}
      <div className="flex flex-col w-full	">
        {/* //! Top NavBar section */}
        <div className="border-b-[1px] w-full sticky h-[60px] z-20 bg-white right-0 top-0 flex flex-row items-center">
          {/* <div className="flex justify-center h-full pr-8">
            <BellIcon className="w-6 ml-auto text-gray-400" />
          </div> */}
          <div className="flex-grow px-2">
            <Input
              leftIcon={<SearchIcon />}
              rightIcon={false}
              size="sm"
              disabled={false}
              error={false}
              value={searchText}
              variant="outline"
              placeholder="Global search"
              onChange={handleChange}
            />
          </div>
          <div className="px-6">Profile Name</div>
        </div>

        {/* //! Content body section for component */}
        <div
          style={{ background: "#F5F6F8" }}
          className="flex-1 px-8 pt-6 pb-8"
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export const BaseLayoutRoute = ({
  component: Component,
  ...args
}: RouteProps) => {
  return (
    <Route
      {...args}
      render={(props) => (
        <BaseLayout>
          <Component {...props} />
        </BaseLayout>
      )}
    />
  );
};
